<template>
    <el-dialog title="扫码签署"
              width="430px"
              class="qr-sign-modal"
              :visible.sync="visible"
              :before-close="doClose"
              v-loading="loading"
              element-loading-text="正在签署中，请稍后...">
        <p class="tips small-font">请扫描以下二维码以完成签署</p>   
        <img :src="qrCodeImage"
              class="qr-code-img">
        <p class="tips" v-if="overTime">请尽快完成签署，<span class="red-text">{{overTime}}S</span> 后自动关闭</p>
    </el-dialog>
</template>

<script>
export default {
    name: 'QrCodeSign',
    props: {
        visible: Boolean,
        locations: Array,
        zwdt_access_token: String
    },
    data () {
        return {
            qrCodeImage: '',
            intervalOverTime: 0,
            overTime: 0
        };
    },
    mounted() {
        this.doStartSign();
    },
    methods: {
        doClose() {
            this.$emit('update:visible', false);
        },

        handleOverTime() {
            this.intervalOverTime = setInterval(() => {
                this.overTime --;
                if(this.overTime === 0){
                    clearInterval(this.intervalOverTime);
                    this.doClose();
                }
            }, 1000);
        },

        /** 获取签署的二维码图片 */
        async doStartSign () {
            const loading = this.$loading({ text: '努力加载中...' });
            try {
                const { data } = await this.axios({
                    url: '/zwdt/view/start/qrcode/sign',
                    method: 'POST',
                    headers: { zwdt_access_token: this.zwdt_access_token },
                    params: { zwdt_access_token: this.zwdt_access_token },
                    responseType: 'arraybuffer',
                    data: {
                        locations: this.locations
                    }
                });
               
                const img = 'data:image/png;base64,' + btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                this.qrCodeImage = img;
                this.overTime = 30;
                this.handleOverTime();
            } catch (error) {
                console.log('%c⧭', 'color: #f2ceb6', error);
            } finally {
                loading.close();
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.intervalOverTime);
    }
};
</script>

<style lang="less">
.qr-sign-modal {
    .el-dialog__body {
        padding-top: 0;
        text-align: center;
    }
    .qr-code-img {
        width: 180px;
        margin: 0 auto;
    }
}
</style>